import { useMemo } from "react";
import { useTheme } from "@mui/material/styles";

/**
 * `customStyle(theme) => ({ formControl: {...}, appBar: {...} })` for merging into `sx` / `className` patterns.
 */
export function useCustomStyleMap(customStyle) {
  const theme = useTheme();
  return useMemo(() => (typeof customStyle === "function" ? customStyle(theme) : {}), [customStyle, theme]);
}
